<template>
    <div class="list-wrap">
        <div class="list-wrap-inner">
            <el-table :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="setTable" :height="listHeight?listHeight:initListHeight" :data="tabledata.listdata" highlight-current-row v-loading="tabledata.listLoading" @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column type="index" width="60" label="序号" align="center">
                </el-table-column>
                <el-table-column v-for="(item,index) in allfields" v-if="item.queryable == 1&&item.default_field == 0" :key="index" :label="item.aliasname" :prop="item.fieldname" align="center">
                    <template slot-scope="scope">
                        <span v-if="reladowndata[item.fieldname]&&reladowndata[item.fieldname][scope.row[item.fieldname]]">{{ reladowndata[item.fieldname][scope.row[item.fieldname]]}}</span>
                        <span v-else>{{ scope.row[item.fieldname]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scopeup" >
                        <!--<el-tooltip class="item" effect="dark" content="下载" placement="bottom" :open-delay="100" v-if="nowSelectModule.funcname == '法律法规文件管理'">-->
                            <!--<em class="operaBtn el-icon-download" @click="downloadFile(scopeup.row.lawfile)" ></em>-->
                        <!--</el-tooltip>-->
                        <el-tooltip class="item" effect="dark" content="查看" placement="bottom" :open-delay="100">
                            <em class="operaBtn icon-ls-view" style="color:rgb(57, 141, 229)" @click="handleEdit(scopeup.$index, scopeup.row)" ></em>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom" :open-delay="100">
                            <em class="operaBtn icon-ls-delete" style="color:#ff2b08" @click="handleDelete(scopeup.$index, scopeup.row)"></em>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--工具条 分页-->
            <el-col :span="24" class="toolbar" style="margin-top:20px;">
                <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="queryParams.size" :total="tabledata.pagetotal" style="float:right;" :current-page="queryParams.page">
                </el-pagination>
            </el-col>
            <!-- 上传图片组件（目前只有法律法规文件管理使用） -->
            <web-up :option-param='webuploaerOptions' ref="webup"></web-up>
            <!-- 输入发布单位和文件名弹窗（目前只有法律法规文件管理使用） -->
            <el-dialog title="法律法规文件上传" :visible.sync="lawDiaVisible" :close-on-click-modal="false" width="460px">
                <el-form :model="lawEditform" label-width="100px" ref="addForm" :inline="true" class="demo-form-inline">
                    <el-form-item label="文件名称">
                        <el-input v-model="lawEditform.filename" auto-complete="off" type="text" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="发布单位">
                        <el-input v-model="lawEditform.publishunit" auto-complete="off" type="text" style="width:300px"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" @click="openWebupDioalog()">选择文件上传</el-button>
                    <el-button size="small" @click.native="addlayerVisible = false">取消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getRefertablefieldinfo , getTablequeryinfo,queryData , deleteUserdata , insertData} from '@/apis/api'
import webUp from "@/components/commomUploader/webuploaerceshi.vue"
import { mapState , mapMutations} from 'vuex'
export default {
    props: ['listHeight','dataOption','enterPosition','theadStyle'],
    components:{
        webUp
    },
    data() {
        return {
            initListHeight:500,      //默认的表格高度
            allfields:null,          //所有字段信息
            reladowndata:{},        //关联下拉数据
            queryParams:{            //查询参数
                resourceid:'',
                sortfield:'operatetime',
                sortkey:'DESC',
                wherekey:'',       //关键字
                page:1,          //当前页
                size:10,         //每页条数
                stime:'',          //开始时间
                etime:'',          //结束时间
                wherejson:'',      //下拉查询
                rangejson:'',      //范围查询
                timefield:'',      //时间字段
                isdataflow:'0',
                unitcode:'',
                regioncode:'',
                authoritytable:'0'
            },
            tabledata:{
                tableH:'480',
                listLoading:false,
                listdata:null,
                pagetotal:20,
                tablethead:[
                    {text:"字段名",type:'fieldname',identifier:"text",isShow:true,isEdit:true,isDisabled:false},
                    {text:"显示名",type:"aliasname",identifier:"text",isShow:true,isEdit:true,isDisabled:false},
                    {text:"字段类型",type:"fieldtype",identifier:"text",isShow:true,isEdit:true,isDisabled:false,"options":[{value: 'varchar',label: 'varchar'},{value: 'int',label: 'int'},{value: 'DATE',label: 'DATE'},{value: 'DATETIME',label: 'DATETIME'},{value: 'numeric',label: 'numeric'},{value: 'BLOB',label: 'BLOB'},{value: 'TEXT',label: 'TEXT'}]},
                    {text:"必填项",type:"nullable",identifier:"text",isShow:true,isEdit:true,isDisabled:false},
                    {text:"查询显示",type:"queryable",identifier:"checkbox",isShow:true,isEdit:true,isDisabled:false},
                    {text:"内建字段",type:"default_field",identifier:"checkbox",isShow:true,isEdit:true,isDisabled:false},
                    {text:"下拉查询",type:"querydroptype",identifier:"checkbox",isShow:true,isEdit:true,isDisabled:false},
                    {text:"日期查询",type:"querydatetype",identifier:"checkbox",isShow:true,isEdit:true,isDisabled:false},
                    {text:"范围查询",type:"queryregiontype",identifier:"checkbox",isShow:true,isEdit:true,isDisabled:false},
                    {text:"全文检索",type:"allindextype",identifier:"checkbox",isShow:true,isEdit:true,isDisabled:false}
                ],


            },
            selectlist:[],       //列表勾选的数据集合
            webuploaerOptions:{
                affixtype: 0,         //0图片   1文件（调用时传入）
                uuid: '',             //附件id       （调用时传入）
                fieldname:'',         //对应字段名    （调用时传入）
                resourceid:'',        //表的uuid     （调用时传入）
                folder_id:'',         //附件所在文件夹的uuid（若指定传到哪个文件夹中，该参数不可为空；若不指定，该参数为空，后台自动存入到默认文件夹中）（调用时传入）
                dataid:'',		      //该条记录的uuid     （调用时传入）
                userid:'',		      //该用户的uuid       （调用时传入）
                allowNum:1,
                callback : function (){},
            },
            lawEditform:{},            //法律法规文件管理完整的数据模型（特例）
            lawDiaVisible:false,       //控制-填写文件名和发布单位的弹窗显示
        }
    },
    methods:{
        ...mapMutations([
            'CHANGEDATAUUID',
            'CHANGEDATAOPERATETYPE',
            'CHANGENOWOPMASDATAID',
            'CHANGEMAINDATAOPERATETYPE'
        ]),
        //修改表格单元格高度
        cellStyle({row, column, rowIndex, columnIndex}){
            return {
                padding:'6px 0',
                "border-color": "#AAAAAA"
            }
        },
        //修改表头样式
        headerCellStyle({row, column, rowIndex, columnIndex}){
            if(this.theadStyle) {
                return this.theadStyle;
            }else {
                return {
                    padding:'6px 0',
                    color:'#5d5d5d',
                    background:'#e5e5e5',
                    "border-color": "#AAAAAA",
                    borderTop:'4px solid #398de5'
                }
            }
        },
        //设置表格高度
        setHeight(data) {
            this.initListHeight = data+'px';
        },
        //字段数据请求
        queryFields() {
            var params = {
                resourceid : this.dataOption.resourceid,
                userid : this.userInfo.uuid,
                isdataflow : '0',
                menuid : ''
            }
            getTablequeryinfo(params).then((res) => {
                if(res.code == '1') {
                    this.allfields = res.result.allfields;
                    for(var i = 0 , ilen = this.allfields.length ; i < ilen ; i++ ) {
                        //存储一份完整的数据模型
                        this.lawEditform[this.allfields[i].fieldname] = '';
                    }
                    this.queryListdata();
                }else {
//                  this.$message({
//                      message: res.message || '服务请求失败！',
//                      type: 'warning'
//                  });
                }
            }).catch((err) => {
//              console.log(err);
                this.$message({
                    message: '服务请求失败！',
                    type: 'warning'
                });
            })
        },
        //查询关联下拉值
        queryReladowndata() {
            var params = {
                resourceid:this.dataOption.resourceid
            }
            getRefertablefieldinfo(params).then((res) => {
                if(res.code == '1') {
//                  console.log(res.result);
                    this.reladowndata = res.result;
                }else {

                }
            })
        },
        //查询列表数据
        queryListdata() {
            this.tabledata.listLoading = true;
            if(this.nowOPmasdataid && this.enterPosition == 'tab-detail') {          //存在主表数据id且入口是详情
                var obj = this.queryParams.wherejson == '' ? {} : JSON.parse(this.queryParams.wherejson);
                this.$set(obj , 'MASDATA_ID' , this.nowOPmasdataid);
                this.queryParams.wherejson = JSON.stringify(obj);
            }
            Object.assign(this.queryParams , {
                resourceid:this.dataOption.resourceid,
                regioncode:this.userInfo.regioncode,
                wherejson:this.$route.query.dropdownmode ? JSON.stringify(this.$route.query.dropdownmode):this.queryParams.wherejson,
                timefield:this.$route.query.date ? this.$route.query.date.timefield:this.queryParams.timefield,
                stime:this.$route.query.date ? this.$route.query.date.stime:this.queryParams.stime,
                etime:this.$route.query.date ? this.$route.query.date.etime:this.queryParams.etime
                })

            queryData(this.queryParams).then((res) => {this.tabledata.listLoading = false;return res;}).then((res) => {
                if(res.code == '1') {
                    this.tabledata.listdata = res.result;
                    this.tabledata.pagetotal = parseInt(res.datacount);
                }else {
                    this.$message({
                        message: res.message || '服务请求失败！',
                        type: 'warning'
                    });
                }
            }).catch((err) => {
//              console.log(err);
                this.$message({
                    message: '服务请求失败！',
                    type: 'warning'
                });
            })
        },
        //分页点击事件
        handleCurrentChange(val) {
//          console.log(val);
            Object.assign(this.queryParams,{page:val});
            this.queryListdata();
        },
        //表格行勾选
        handleSelectionChange(val) {
//          console.log(val);
            this.selectlist = val;
        },
        //表格查看
        handleEdit(index,row) {
//          console.log(index);
//          console.log(row.uuid);
//          console.log(this.enterPosition);
            this.CHANGEDATAUUID(row.uuid);
            this.CHANGEDATAOPERATETYPE(1);
            if(this.enterPosition == "tab-list") {
                this.$router.push({path:'main/have/tabdetail',name:'tabdetail',params:{uuid:row.uuid}});
                this.CHANGENOWOPMASDATAID (row.uuid);
                this.CHANGEMAINDATAOPERATETYPE(1);
            }else if(this.enterPosition == "form-list") {
                this.$router.push({path:'main/have/formdetail',name:'formdetail',params:{uuid:row.uuid}});
                this.CHANGENOWOPMASDATAID ('');
            }else if(this.enterPosition == "tab-detail") {
                window.location.href = "#aaa";
            }
        },
        //表格删除(单条数据删除)
        handleDelete(index,row) {
            this.$confirm('是否要删除该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
//                  console.log(row);
                    this.doDelete([row.uuid]);
                    // return;

                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

        },
        //数据删除请求接口
        doDelete(ids) {
            var params = {
                uuid:ids.join(','),
                resourceid:this.dataOption.resourceid,
            }
            deleteUserdata(params).then((res) => {
                if(res.code == '1') {
                    this.$message({
                        message: res.message || '删除成功！',
                        type: 'success'
                    });
                    this.queryListdata();           //重新查询列表信息
                }else {
                    this.$message({
                        message: res.message || '删除失败！',
                        type: 'warning'
                    });
                }
            }).catch((err) => {
//              console.log(err);
                this.$message({
                    message: '服务请求失败！',
                    type: 'warning'
                });
            })
        },
        //点击上传按钮
        clickUploader() {
            this.lawDiaVisible = true;
//          console.log(this.timestampToTime(new Date().getTime()));
            this.lawEditform.username = this.userInfo.name;
            this.lawEditform.uploadtime = this.timestampToTime(new Date().getTime());
            this.lawEditform.regioncode = this.userInfo.regioncode;
            var uuid = this.guid()
            this.lawEditform.uuid = uuid;
            this.CHANGEDATAUUID(uuid);

        },
        //打开文件上传窗口
        openWebupDioalog() {
            var _this = this;

            this.webuploaerOptions.uuid = '';
            this.webuploaerOptions.fieldname = 'lawfile';
            this.webuploaerOptions.resourceid = this.nowOPTBresourceid;
            this.webuploaerOptions.folder_id = '';
            this.webuploaerOptions.dataid = this.datauuid;
            this.webuploaerOptions.userid = this.userInfo.uuid;
            this.webuploaerOptions.callback = uploadSuccessCallback;
            this.$refs.webup.showDialog();

            function uploadSuccessCallback(data) {
                _this.lawEditform.lawfile = data.uuid;
                var params = {
                    userid: _this.userInfo.uuid,
                    datauuid: _this.datauuid,
                    resourceid: _this.dataOption.resourceid,
                    data: JSON.stringify(_this.lawEditform),
                    isdataflow: '0'
                };
//              console.log(params);
                insertData(params).then((res) => {
                    if(res.code == '1') {
                        _this.$message({
                            message: res.message || '保存成功！',
                            type: 'success'
                        });
                        _this.$bus.$emit('querydata')
                    }else {
                        _this.$message({
                            message: res.message || '保存失败！',
                            type: 'warning'
                        });
                    }
                }).catch((err) => {
//                  console.log(err);
                    _this.$message({
                        message: '服务请求失败！',
                        type: 'warning'
                    });
                })
            }
        },
        //文件下载
        downloadFile(uuid) {
            var url = this.URL_PREFIX+'irriproject/'+'filedownload.spring?fileuuid='+uuid;
            window.open(encodeURI(url), "_blank");
        },
        //---------- 工具方法 ----------
        timestampToTime(timestamp) {
//          console.log(timestamp)
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y,M,D,h,m,s;
//          console.log(date);
            Y = date.getFullYear();
            M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) ;
            D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            h = date.getHours() ;
            m = date.getMinutes();
            s = date.getSeconds();
            return Y+'-'+M+'-'+D+' '+h+':'+m+':'+s;
        },
        //生成随机数
        guid() {
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
            return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
        },

    },
    computed: {
        ...mapState([
            'userInfo',
            'datauuid',
            'nowSelectModule',
            'nowOPmasdataid',
            'nowOPTBresourceid'
        ]),

    },
    watch: {
        dataOption: {
            handler:function(val,oldval){
                this.queryFields();
                this.queryReladowndata();
            },
            deep:true
        },
    },
    mounted() {
        var _this = this;
        this.$bus.$on('querydata',(target) => {
            if(target) {
                _this.queryParams = target.queryParams;
            }
//          console.log(_this.queryParams)
            _this.queryListdata();

        });
        this.$bus.$on('deletedata',(target) => {
//          console.log(this.selectlist);
            if(this.selectlist.length <= 0) {
                this.$message({
                    message: '请选择要删除的数据！',
                    type: 'warning'
                });
            }else {
                this.$confirm('是否要删除这'+this.selectlist.length+'条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    // console.log(row);
                    var ids = [];
                    for(var i = 0 , ilen = this.selectlist.length ; i < ilen ; i++) {
                        ids.push(this.selectlist[i].uuid);
                    }
                    this.doDelete(ids);

                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            }
        });
        this.$bus.$on('uploadfiles',(target) => {
            this.clickUploader();
            // this.openWebupDioalog();
        });
        this.queryFields();
        this.queryReladowndata();
    }
}
</script>

<style lang="less" scoped>
    .list-wrap {
        width: 98%;
        margin: 10px auto 0;

        background-color: #fff;
        .list-wrap-inner {
            padding: 10px;
        }
    }
    .operaBtn {
        font-size: 22px;
        color: #53c79f;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/sysmodule/tab/listpart.vue